import { ErrorMessage } from '@hookform/error-message';
import { Checkbox, Col, Input, Row, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import ImageUpload from '../../../fit-studio/components/upload/ImageUpload';
import { MdDelete } from 'react-icons/md';

const AnswerCard = ({ item, index, remove, disabled }) => {
  const [view, setView] = useState(false);
  const { control, errors, watch } = useFormContext();

  useEffect(() => {
    if (item.imageUrl) {
      setView(true);
    }
  }, [item.imageUrl]);

  if (['ไม่มีคำตอบ', 'อื่นๆ โปรดระบุ'].includes(item.answer)) {
    return null;
  }

  console.log(watch(`answers.${index}.weight`));

  return (
    <div key={item.id}>
      <Row className="align-items-center  mb-2">
        <Col span={4}>
          <Typography.Text>
            คำตอบ {index + 1} <span style={{ color: 'red' }}>*</span>
          </Typography.Text>
        </Col>
        <Col span={14}>
          <Controller
            name={`answers.${index}.answer`}
            control={control}
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => {
              return (
                <Input.TextArea
                  value={value}
                  onChange={onChange}
                  placeholder="คำตอบ"
                  rows={2}
                  disabled={disabled}
                />
              );
            }}
          />
          <ErrorMessage
            errors={errors}
            name={`answers.${index}.answer`}
            render={({ message }) => (
              <Typography.Text className="mb-2 text-danger">
                {message}
              </Typography.Text>
            )}
          />
        </Col>
        {watch('answerType') === 'weight' && (
          <Controller
            name={`answers.${index}.weight`}
            control={control}
            rules={{
              ...(watch('answerType') === 'weight' && {
                required: 'กรุณากรอกระดับคะแนน',
                min: {
                  value: 1,
                  message: 'กรุณากรอกระดับคะแนนอย่างน้อย 10',
                },
              }),
            }}
            render={({ field: { onChange, value } }) => {
              return (
                <Col span={4} style={{ paddingLeft: 10, paddingRight: 10 }}>
                  <Typography.Text>ระดับคะแนน</Typography.Text>
                  <Input
                    value={value}
                    onChange={(value) => {
                      onChange(Math.abs(value.target.value));
                    }}
                    type="number"
                    disabled={disabled}
                  />
                  <ErrorMessage
                    errors={errors}
                    name={`answers.${index}.weight`}
                    render={({ message }) => (
                      <Typography.Text className="mb-2 text-danger">
                        {message}ะำหะำห
                      </Typography.Text>
                    )}
                  />
                </Col>
              );
            }}
          />
        )}
        {!disabled && (
          <Col span={1}>
            <div
              style={{
                cursor: 'pointer',
                marginLeft: 20,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
              onClick={() => {
                remove(index);
              }}
            >
              <MdDelete />
            </div>
          </Col>
        )}
      </Row>
      <Controller
        name={`answers.${index}.imageUrl`}
        control={control}
        render={({ field: { value, onChange } }) => {
          return (
            <Row className="align-items-center mb-2">
              <Col span={4}></Col>
              <Col span={20}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Checkbox
                    checked={view}
                    onChange={(value) => {
                      if (!value.target.checked) {
                        onChange('');
                      }
                      setView(value.target.checked);
                    }}
                    className="mr-2"
                    disabled={disabled}
                  />
                  <Typography.Text>ภาพคำตอบ</Typography.Text>
                  <Controller
                    name={`answers.${index}.isComment`}
                    control={control}
                    render={({ field: { value, onChange } }) => {
                      return (
                        <Checkbox
                          checked={value}
                          onChange={(value) => {
                            onChange(value.target.checked);
                          }}
                          className="mx-2"
                          disabled={disabled}
                        />
                      );
                    }}
                  />
                  <Typography.Text>มีช่องแสดงความคิดเห็น</Typography.Text>
                </div>
                {view && (
                  <ImageUpload
                    value={value}
                    onChange={onChange}
                    width={100}
                    height={100}
                    errors={errors}
                    notRequired
                    disabled={disabled}
                  />
                )}
              </Col>
            </Row>
          );
        }}
      />
    </div>
  );
};

export default AnswerCard;
